<template>
  <div class="pa-5">
    <div
      id="box_login"
      class="vuetifycss container pa-0"
    >
      <login />
    </div>
  </div>
</template>

<script>
import login from '../login/login.vue'

export default {
  name: 'BorrowerLogin',
  components: {
    login: login
  },
  created () {
    this.$store.sidenav = false
  }
}
</script>
